module.exports = __webpack_public_path__ + "static/media/Joe Sapp Headshot.17b110b1.jpeg";